export const getBuildingDefaultName = (buildingIndex: number): string =>
  'building' + (buildingIndex + 1);
